module.exports = __webpack_public_path__ + "img/1.4ab6e218.png";